/**
 * The filled circle with a knocked-out × beside an error message. Figma 10188:14965
 * ("options_off"), drawn at 16px in 10188:18323; the path is the filled variant of
 * Fusion's `OptionsOffIcon` (mfr/OptionsOffIconForSS.tsx), copied as data, not imported.
 * The viewBox is Fusion's standard 36-unit box (`0 0 36 36`), which at 16px draws the 8px circle
 * with its built-in margin, as the Figma render does. The fill is `currentColor` at the call site.
 */
export const OPTIONS_OFF_GLYPH_VIEWBOX = "0 0 36 36";

export const OPTIONS_OFF_GLYPH_PATH =
  "M18 9C13.03 9 9 13.03 9 18C9 22.97 13.03 27 18 27C22.97 27 27 22.97 27 18C27 13.03 22.97 9 18 9ZM22.76 " +
  "21.34C23.15 21.73 23.15 22.36 22.76 22.75C22.56 22.95 22.31 23.04 22.05 23.04C21.79 23.04 21.54 22.94 " +
  "21.34 22.75L18 19.41L14.65 22.76C14.45 22.96 14.2 23.05 13.94 23.05C13.68 23.05 13.43 22.95 13.23 " +
  "22.76C12.84 22.37 12.84 21.74 13.23 21.35L16.58 18L13.24 14.66C12.85 14.27 12.85 13.64 13.24 13.25C13.63 " +
  "12.86 14.26 12.86 14.65 13.25L17.99 16.59L21.33 13.25C21.72 12.86 22.35 12.86 22.74 13.25C23.13 13.64 " +
  "23.13 14.27 22.74 14.66L19.4 18L22.74 21.34H22.76Z";
